<template>
  <div class="box">
    <div class="top">
      <p>群众需求情况</p>
      <div class="border"></div>
      <div class="back">
        <img src="../../assets/images/back.png" alt="" />
        <span>返回</span>
      </div>
    </div>
    <div class="nav">
      <div
        :class="[selectIndex == index ? 'select' : '', 'item']"
        v-for="(item, index) in navlist"
        :key="index"
        @click="select(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="item in list" :key="item.id">
        <div class="left">{{ item.name }}</div>
        <div class="right">
          <img src="../../assets/images/source.png" alt="" />
          <span>来源:XXXXXXXXXXX</span>
        </div>
      </div>
      <Pagination :total="total" @pagination="getList" />
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/pagination";
export default {
  data() {
    return {
      selectIndex: 0,
      navlist: [
        { name: "医疗卫生（99）", id: 0 },
        { name: "社区营造", id: 1 },
        { name: "社区营造", id: 2 },
        { name: "社区营造", id: 3 },
        { name: "社区营造", id: 4 },
      ],
      total: 90,
      list: [
        { name: "医疗卫生", id: 0 },
        { name: "社区营造", id: 1 },
        { name: "社区营造", id: 2 },
        { name: "社区营造", id: 3 },
        { name: "社区营造", id: 4 },
        { name: "医疗卫生", id: 5 },
      ],
    };
  },

  components: {
    Pagination,
  },

  computed: {},

  create() {},

  mounted() {
    // let url = "";
    // this.postRequest(url)
    //   .then((response) => {
    //     console.log(response);
    //   })
    //   .catch(() => {});
  },

  methods: {
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 切换nav
    select(index) {
      this.selectIndex = index;
    },
    // 获取列表
    getList(e) {
      console.log(e);
    },
  },
};
</script>
<style lang='less' scoped>
.box {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/bg.jpg") no-repeat center/100% 100%;
  .top {
    height: 90px;
    overflow: hidden;
    position: relative;
    background: url("../../assets/images/top_bg.png") no-repeat center/100% 100%;
    p {
      font-size: 32px;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.9);
      text-align: center;
      margin-top: 25px;
    }
    .back {
      position: absolute;
      top: 14px;
      right: 43px;
      font-size: 24px;
      font-weight: 400;
      color: #4977fc;
      cursor: pointer;
      img {
        width: 20px;
        height: 21px;
        margin-right: 9px;
      }
    }
  }
  .nav {
    display: flex;
    justify-content: center;
    .item {
      width: 374px;
      height: 110px;
      text-align: center;
      line-height: 110px;
      font-size: 36px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.5);
      background: url("../../assets/images/noselect.png") no-repeat center/100%
        100%;
      background-size: 100%;
      cursor: pointer;
    }
    .select {
      font-size: 44px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      background: url("../../assets/images/select.png") no-repeat center/100%
        100%;
    }
  }
  .list {
    padding: 0 20px;
    width: 1810px;
    height: 758px;
    background: url("../../assets/images/content.png") no-repeat center/100%
      100%;
    margin: 34px auto 0;
    position: relative;
    .item {
      height: 100px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      background: url("../../assets/images/item.png") no-repeat center/100% 100%;
      padding-left: 34px;
      .left {
        font-size: 36px;
        font-weight: 400;
        color: #ffffff;
        width: 1200px;
      }
      .right {
        margin-left: 226px;
        font-size: 28px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.4);
        display: flex;
        line-height: 0;
        align-items: center;
        height: 60px;
        img {
          width: 30px;
          height: 30px;
          margin-right: 7px;
        }
      }
    }
  }
}
</style>